import { Box } from "@chakra-ui/react"
import { Footer } from "@/-components/Footer"
import { JoinBanner } from "@/-sections/JoinBanner"
import Logos from "@/-sections/Logos"
import { PricingFAQs } from "@/-sections/FAQs/Pricing"
import PricingWithTable from '@/-sections/Pricing/PricingWithTable'

// import dynamic from 'next/dynamic'
// const PricingWithTable = dynamic(() => import('../../components/Pricing/PricingWithTable'), { ssr: false })

const Pricing = () => {
  return (
    <Box w="full" bg="white">
      <PricingWithTable />
      <PricingFAQs />
      <Logos />
      <JoinBanner bgColor="#034024" />
      <Footer bgColor="#034024" />
    </Box>
  )
}

export default Pricing